module.exports = __webpack_public_path__ + "img/droadfooter.46ba3ae6.jpg";